import { Box, Grid } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { SectionHead } from "@/components";
import { KNIT_OFF_MACHINE, KNIT_OFF_MACHINE_HEAD } from "@/content";
import { OffMachineVideo, type OffMachineVideoHandle } from "./knit/OffMachineVideo";
import { StepList } from "./knit/StepList";

export const KnittingOffMachine = () => {
  const videoRef = useRef<OffMachineVideoHandle>(null);
  const [step, setStep] = useState(0);

  return (
    <Box as="section" id="off-machine" maxW="maxw" mx="auto" px="pad" pb="sec">
      <SectionHead head={KNIT_OFF_MACHINE_HEAD} />

      <Grid
        templateColumns={{ base: "minmax(0, 1fr)", lg: "minmax(0, 1.25fr) minmax(0, 0.75fr)" }}
        gap="clamp(32px, 4vw, 56px)"
        alignItems="start"
      >
        <OffMachineVideo ref={videoRef} onStepChange={setStep} />
        <StepList
          label={KNIT_OFF_MACHINE.stepsLabel}
          steps={KNIT_OFF_MACHINE.steps}
          active={step}
          onSelect={(index) => videoRef.current?.showStep(index)}
        />
      </Grid>
    </Box>
  );
};
